import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    console.log("Health status controller connected")
  }

  async retry(event) {
    event.preventDefault()
    const button = event.currentTarget
    const accountId = this.element.dataset.accountId
    
    try {
      this.setLoading(button)
      
      const response = await fetch(`/admin/account_budgets/${accountId}/sync`, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
          'Accept': 'text/vnd.turbo-stream.html',
          'Content-Type': 'application/json'
        }
      })

      if (!response.ok) throw new Error('Sync failed')
      
      // Let Turbo handle the frame update
      const html = await response.text()
      Turbo.renderStreamMessage(html)
    } catch (error) {
      console.error('Sync retry failed:', error)
      this.setError(button)
    }
  }

  setLoading(button) {
    button.disabled = true
    button.innerHTML = '<span class="inline-flex items-center">Syncing... <svg class="animate-spin ml-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg></span>'
  }

  setSuccess(button) {
    button.innerHTML = 'Synced!'
    setTimeout(() => {
      button.disabled = false
      button.innerHTML = 'Retry Sync'
    }, 2000)
  }

  setError(button) {
    button.innerHTML = 'Sync Failed'
    setTimeout(() => {
      button.disabled = false
      button.innerHTML = 'Retry Sync'
    }, 2000)
  }
}